import { useEffect } from 'react';

import type { MentionProvider } from '@atlaskit/mention/types';

import type { RovoMentionNodeDataProvider } from './useRovoMentionNodeDataProvider';

type RovoMentionNodeDataProviderConnectorProps = {
	mentionNodeDataProvider: RovoMentionNodeDataProvider;
	mentionResource: Promise<MentionProvider>;
};

/** Mounted only in the experiment variant so the control path registers no new effect. */
export const RovoMentionNodeDataProviderConnector = ({
	mentionNodeDataProvider,
	mentionResource,
}: RovoMentionNodeDataProviderConnectorProps): null => {
	useEffect(
		() => mentionNodeDataProvider.connect(mentionResource),
		[mentionNodeDataProvider, mentionResource],
	);
	return null;
};
